import { setSnackError } from "../Reducers/snackErrors";

// utils/errorHandler.js
export const handleApiError = (error, dispatch, context = 'operation') => {
    if (error.isAuthError || error.isForbidden) {
      return null;
    }
  
    if (error.isNetworkError) {
      dispatch(setSnackError({ 
        title: 'Connection Error', 
        body: error.message 
      }));
    } else {
      dispatch(setSnackError({
        title: 'Error',
        body: error.message || `Unable to ${context}.`
      }));
    }
    
    return null;
  };